import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import { useSetState } from 'react-use';

import axios from 'axios';
import cookies from 'js-cookie';
import to from 'await-to-js'
import Button from 'molecules/Button';
import Checkbox from 'molecules/Checkbox';
import Form, { WrappedForm } from 'organisms/Form';
import Image from 'molecules/Image';
import Input from 'molecules/Input';
import MaskedInput from 'molecules/MaskedInput';
import Radio from 'molecules/Radio';
import Select from 'molecules/Select';
import { buildSelectOptions } from 'lib/helpers';



/**
 * Assessment form.
 *
 * Sample params: http://localhost:8000/complete-assessment?email=test@testy.com&pilotType=
 */
const propTypes = {
  parentState: PropTypes.object,
  Most_Recent_Lead_Source_Specific__c: PropTypes.string,
}
const AssessmentForm = React.memo( p => {

  const { sfPicklist } = useStaticQuery( graphql`
    query AssessmentMultiStep2Query {
      sfPicklist {
        cityOptions {
          label
          value
        }
        orgPilotAmountOptions {
          label
          value
        }
        orgBudgetOptions {
          label
          value
        }
        entBudgetOptions {
          label
          value
        }
        entExperienceOptions {
          label
          value
        }
        entGoalOptions {
          label
          value
        }
        entServiceOptions {
          label
          value
        }
        experienceOptions {
          label
          value
        }
        recBudgetOptions {
          label
          value
        }
        verticalOptions {
          label
          value
        }
      }
    }
  ` );

  const verticalOptions = buildSelectOptions( {
    items:      sfPicklist.verticalOptions,
    valueKey:   'value',
    contentKey: 'label',
    selectText: 'Select one',
  } );
  const cityOptions = buildSelectOptions( {
    items:      sfPicklist.cityOptions,
    valueKey:   'label',
    contentKey: 'label',
    selectText: 'Select one',
  } );
  const orgPilotOptions = buildSelectOptions( {
    items:      sfPicklist.orgPilotAmountOptions,
    valueKey:   'label',
    contentKey: 'label',
    selectText: 'Select one',
  } );
  const orgBudgetOptions = buildSelectOptions( {
    items:      sfPicklist.orgBudgetOptions,
    valueKey:   'label',
    contentKey: 'label',
    selectText: 'Select one',
  } );
  const pilotExperienceOptions = buildSelectOptions( {
    items:      sfPicklist.experienceOptions,
    valueKey:   'label',
    contentKey: 'label',
    selectText: 'Select one',
  } );
  const entBudgetOptions = buildSelectOptions( {
    items:      sfPicklist.entBudgetOptions,
    valueKey:   'label',
    contentKey: 'label',
    selectText: 'Select one',
  } );
  const entGoalOptions = buildSelectOptions( {
    items:      sfPicklist.entGoalOptions,
    valueKey:   'label',
    contentKey: 'label',
    selectText: 'Select one',
  } );
  const recBudgetOptions = buildSelectOptions( {
    items:      sfPicklist.recBudgetOptions,
    valueKey:   'label',
    contentKey: 'label',
    selectText: 'Select one',
  } );


  let email = p.parentState && p.parentState.email ? p.parentState.email : null;
  let pilotType = p.parentState && p.parentState.pilotType ? p.parentState.pilotType : null;

  if(
    ( ! email || ! pilotType ) &&
    typeof window !== 'undefined'
  ) {

    const queryString = require( 'query-string' );
    const qs = queryString.parse( window.location.search );

    email = qs.email;
    pilotType = qs.pilotType;

  }


  /* ------ = Output. = --------------------------------------------------------------------- */
  const className = classnames(
    'AssessmentForm',
    p.className
  );

  if( typeof window !== 'undefined' && ! email || ! pilotType ) {
    return <div>We're sorry, we have trouble processing your first step. Are you sure you entered the full url?</div>
  }

  return(

    <div className={ className }>

      <WrappedForm
      memo={ null }
      withLabels={ false }
      form={ formProps => {

        const { getFieldDecorator } = formProps.form;
        const [ formState, setFormState ] = useSetState( {
          isProcessing: false,
          isCompleted: false,
        } );

        const handleSubmit = async e => {
          e.preventDefault();

          formProps.form.validateFields( async ( errors, values ) => {

            // Uh oh...
            if( errors ) {
              return;
            }

            setFormState( {
              isProcessing: true,
            } );


            // Submit to ss.
            const [ err, response ] = await to( axios.post( `${window.FUNCTIONS_URL}/sf-submit-form`, {
              ...values,
              Email: email,
              Most_Recent_Lead_Source_Specific__c: p.Most_Recent_Lead_Source_Specific__c || 'Assessment Step 2 Form',
              Ad_Source__c: cookies.get( 'adsource' ),
            } ) );

            if( err ) {
              console.warn( err );

              if( !! p.parentState ) {
                p.parentState.setState( {
                  isCompleted: true,
                  hasError: true,
                } );
              }

            }
            else {

              setFormState( {
                isCompleted: true,
              } );

              if( !! p.parentState ) {
                p.parentState.setState( {
                  isCompleted: true
                } );
              }
            }

          } );

        }

        if( ! formState.isCompleted ) {

          return(

            <Form onSubmit={ handleSubmit }>

                  <div className="row">

                    <div className="col-md-6">
                      <Form.Item label="First Name">
                        { getFieldDecorator( 'FirstName', {
                          rules: [ {
                            required: true,
                            message: 'Please enter your first name.',
                          } ],
                        } )(
                          <Input
                          />
                        ) }
                      </Form.Item>
                    </div>

                    <div className="col-md-6">
                      <Form.Item label="Last Name">
                        { getFieldDecorator( 'LastName', {
                          rules: [ {
                            required: true,
                            message: 'Please enter your last name.',
                          } ],
                        } )(
                          <Input
                          />
                        ) }
                      </Form.Item>
                    </div>

                  </div>


                  <Form.Item label="Phone Number (optional)">
                    { getFieldDecorator( 'Phone', {
                      // rules: [ {
                      //   required: true,
                      //   message: 'Please enter your last name.',
                      // } ],
                    } )(
                      <MaskedInput
                      mask="(111) 111-1111"
                      />
                    ) }
                  </Form.Item>


                  <Form.Item label={ 'Preferred DARTdrones Location' }>
                    { getFieldDecorator( 'Primary_Desired_City__c', {
                      rules: [ {
                        required: true,
                        message: 'Please select a location.',
                      } ],
                      initialValue: '',
                    } )(
                      <Select>
                        { cityOptions }
                      </Select>
                    ) }
                  </Form.Item>

                  { do {

                    if( pilotType === 'Recreational' || pilotType.includes( 'fun' ) ) {

                      return(
                        <>

                          <Form.Item label="How much are you planning to spend on a drone / did you spend already?">
                            { getFieldDecorator( 'FORM_Recreation_Drone_Equipment_Spend__c', {
                              rules: [ {
                                required: true,
                                message: 'Please select a value.',
                              } ],
                              initialValue: '',
                            } )(
                              <Select>
                                { recBudgetOptions }
                              </Select>
                            ) }
                          </Form.Item>

                          <Form.Item
                          label="Do you currently fly drones?"
                          style={ { /* marginTop: '0.25rem' */ } }
                          >
                            { getFieldDecorator( 'AC_Pilot_Experience_Level__c', {
                              rules: [ {
                                required: true,
                                message: 'Please select a value.',
                              } ],
                              initialValue: '',
                            } )(

                              <Select>
                                { pilotExperienceOptions }
                              </Select>

                            ) }
                          </Form.Item>

                        </>
                      )
                    }

                    else if( pilotType === 'Drone Entrepreneur' || pilotType.includes( 'business' ) ) {

                      return(
                        <>

                          <Form.Item label="What best describes your goals?">
                            { getFieldDecorator( 'FORM_Entrepreneur_Goals__c', {
                              rules: [ {
                                required: true,
                                message: 'Please select a value.',
                              } ],
                              initialValue: '',
                            } )(
                              <Select>
                                { entGoalOptions }
                              </Select>
                            ) }
                          </Form.Item>

                          <Form.Item
                          label="What type of drone services do you want to offer? Check all that apply."
                          style={ { marginTop: '1.25rem' } }
                          >
                            { getFieldDecorator( 'FORM_Entrepreneur_Services_Offered__c', {
                              rules: [ {
                                required: true,
                                message: 'Please select a value.',
                                type: 'array',
                              } ],
                              initialValue: [],
                            } )(
                              <Checkbox.Group>
                                { !! sfPicklist.entServiceOptions && sfPicklist.entServiceOptions.map( service => (
                                  <Checkbox value={ service.label }>{ service.value }</Checkbox>
                                ) ) }
                              </Checkbox.Group>
                            ) }
                          </Form.Item>

                          <Form.Item
                          label="Do you currently fly drones?"
                          style={ { /* marginTop: '0.25rem' */ } }
                          >
                            { getFieldDecorator( 'AC_Pilot_Experience_Level__c', {
                              rules: [ {
                                required: true,
                                message: 'Please select a value.',
                              } ],
                              initialValue: '',
                            } )(

                              <Select>
                                { pilotExperienceOptions }
                              </Select>

                            ) }
                          </Form.Item>

                          <Form.Item
                          label="Do you have your FAA Part 107 Remote Pilot Certificate"
                          >
                            { getFieldDecorator( 'AC_Part_107_Certified_Status__c', {
                              rules: [ {
                                required: true,
                                message: 'Please select a value.',
                              } ],
                              initialValue: '',
                            } )(
                              <Radio.Group>
                                <Radio.Button value="Yes">Yes</Radio.Button>
                                <Radio.Button value={ "No" }>No</Radio.Button>
                              </Radio.Group>
                            ) }
                          </Form.Item>

                          <Form.Item label="How much are you planning to spend on a drone / did you spend already?">
                            { getFieldDecorator( 'FORM_Entrepreneur_Drone_Spend__c', {
                              rules: [ {
                                required: true,
                                message: 'Please select a value.',
                              } ],
                              initialValue: '',
                            } )(
                              <Select>
                                { entBudgetOptions }
                              </Select>
                            ) }
                          </Form.Item>

                        </>
                      )
                    }
                    else if( pilotType === 'Enterprise' || pilotType.includes( 'organization' ) ) {

                      return(
                        <>

                          <Form.Item label="Organization Name">
                            { getFieldDecorator( 'Company', {
                              // rules: [ {
                              //   required: true,
                              //   message: 'Enter a value',
                              // } ],
                            } )(
                              <Input />
                            ) }
                          </Form.Item>

                          <Form.Item label="I’m interested in using drones for">
                            { getFieldDecorator( 'Vertical__c', {
                              rules: [ {
                                required: true,
                                message: 'Please select a value',
                              } ],
                              initialValue: '',
                            } )(
                              <Select>
                                { verticalOptions }
                              </Select>
                            ) }
                          </Form.Item>

                          <Form.Item label="How many drone pilots will your organization utilize in the next two years?">
                            { getFieldDecorator( 'FORM_Organization_Number_of_Pilots__c', {
                              rules: [ {
                                required: true,
                                message: 'Please select a value.',
                              } ],
                              initialValue: '',
                            } )(
                              <Select>
                                { orgPilotOptions }
                              </Select>
                            ) }
                          </Form.Item>

                          <Form.Item label="Do you currently fly drones?">
                            { getFieldDecorator( 'AC_Pilot_Experience_Level__c', {
                              rules: [ {
                                required: true,
                                message: 'Please select a value.',
                              } ],
                              initialValue: '',
                            } )(
                              <Select>
                                { pilotExperienceOptions }
                              </Select>
                            ) }
                          </Form.Item>

                          <Form.Item
                          label="Do you have your FAA Part 107 Remote Pilot Certificate"
                          >
                            { getFieldDecorator( 'AC_Part_107_Certified_Status__c', {
                              rules: [ {
                                required: true,
                                message: 'Please select a value.',
                              } ],
                              initialValue: '',
                            } )(
                              <Radio.Group>
                                <Radio.Button value="Yes">Yes</Radio.Button>
                                <Radio.Button value={ "No" }>No</Radio.Button>
                              </Radio.Group>
                            ) }
                          </Form.Item>

                          <Form.Item label="How much are you planning to spend on a drone / did you spend already?">
                            { getFieldDecorator( 'FORM_Organization_Future_Spend__c', {
                              rules: [ {
                                required: true,
                                message: 'Please select a value.',
                              } ],
                              initialValue: '',
                            } )(
                              <Select>
                                { orgBudgetOptions }
                              </Select>
                            ) }
                          </Form.Item>

                        </>
                      )
                    }

                  } }

                  <Form.Item
                  label="Would you like to setup a call with one of our Enrollment Specialists to consult you on how to get started?"
                  style={ { marginTop: '0.25rem' } }
                  >
                    { getFieldDecorator( 'FORM_Set_up_a_call__c', {
                      rules: [ {
                        required: true,
                        message: 'Please select a value.',
                      } ],
                      initialValue: '',
                    } )(
                      <Radio.Group>
                        <Radio.Button value="Yes">Yes</Radio.Button>
                        <Radio.Button value="No">No</Radio.Button>
                      </Radio.Group>
                    ) }
                  </Form.Item>

                  <Button
                  htmlType="submit"
                  isBusy={ formState.isProcessing }
                  color="green"
                  size="lg"
                  style={ {
                    width: '100%',
                    marginTop: '1rem',
                  } }
                  >
                    Get my Assessment
                  </Button>
                </Form>

          )

        }
        else {

          const ContactRep = require( 'organisms/ContactRep' ).default;

          let salesRepData = {};
          let expertLabel = '';
          if( pilotType === 'Flying for my organization' ) {
            expertLabel = 'Enterprise Account Manager';
            salesRepData = {
              salesRepPhoto: 'https://cdn.sanity.io/images/bcah6zuu/production/bfeea9889b7cea05ecf2ea9463613adb7de708ff-750x826.jpg',
              salesRep: {
                firstname:  'Mike',
                lastname:   'McCann',
                phone:      '1-800-264-3907',
                extension:  '701',
              }
            }
          }
          else if( pilotType === 'Starting a drone business/career' ) {
            expertLabel = 'Starting a Drone Business Expert';
            salesRepData = {
              salesRepPhoto: 'https://cdn.sanity.io/images/bcah6zuu/production/3ee13659abb38ad2b41fe1688c22626be8bfb160-901x1208.jpg',
              salesRep: {
                firstname:  'Jordan',
                lastname:   'Kenczka',
                phone:      '1-800-264-3907',
                extension:  '728',
              }
            }
          }
          else if( pilotType === 'Flying for fun' ) {
            expertLabel = 'Enrollment Specialist';
            salesRepData = {
              salesRepPhoto: 'https://cdn.sanity.io/images/bcah6zuu/production/3ee13659abb38ad2b41fe1688c22626be8bfb160-901x1208.jpg',
              salesRep: {
                firstname:  'Jordan',
                lastname:   'Kenczka',
                phone:      '1-800-264-3907',
                extension:  '728',
              }
            }
          }

          return(

            <div className="PopupMulti__completed">

                <p className="PopupMulti__completed-msg">
                  Thank you for your interest in the drone industry! We look forward to working with you.
                  &nbsp;<span style={ {  fontWeight: '700', textDecoration: 'underline' } }>Your assessment will be in your email inbox within an hour</span>.&nbsp;
                  { `Please don’t hesitate to reach out to our ${expertLabel} if you have questions.`}
                </p>

                <ContactRep
                data={ {
                  salesRepPhoto: salesRepData.salesRepPhoto,
                  salesRep: salesRepData.salesRep,
                } }
                hideLeaveMessage={ true }
                />

            </div>

          )
        }

      } }
      />

    </div>

  )

} );
AssessmentForm.propTypes = propTypes;

export default AssessmentForm;
